import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentResult({ cancelled = false }) {
  const { t } = useLanguage();
  const [state, setState] = useState(cancelled ? "cancelled" : "processing");
  const sessionId = new URLSearchParams(window.location.search).get("session_id");

  useEffect(() => {
    if (cancelled || !sessionId) {
      if (!cancelled && !sessionId) setState("failed");
      return;
    }
    let attempts = 0;
    const tick = async () => {
      attempts += 1;
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState("paid");
          return;
        }
      } catch (e) {
        /* keep polling */
      }
      if (attempts >= 8) {
        setState("failed");
        return;
      }
      setTimeout(tick, 2500);
    };
    tick();
  }, [cancelled, sessionId]);

  return (
    <main className="pt-[72px] min-h-screen flex items-center justify-center px-5">
      <div
        data-testid={`payment-result-${state}`}
        className="w-full max-w-lg rounded-2xl border border-white/10 bg-[#0F1015] p-10 text-center"
      >
        {state === "processing" && (
          <>
            <Loader2 size={40} className="mx-auto animate-spin text-gold" />
            <h1 className="mt-6 font-display text-xl font-bold">{t.pay.processing}</h1>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 size={44} className="mx-auto text-gold" />
            <h1 className="mt-6 font-display text-2xl font-bold">{t.pay.successTitle}</h1>
            <p className="mt-3 text-sm text-slate-400">{t.pay.successBody}</p>
          </>
        )}
        {state === "cancelled" && (
          <>
            <XCircle size={44} className="mx-auto text-slate-400" />
            <h1 className="mt-6 font-display text-2xl font-bold">{t.pay.cancelTitle}</h1>
            <p className="mt-3 text-sm text-slate-400">{t.pay.cancelBody}</p>
          </>
        )}
        {state === "failed" && (
          <>
            <XCircle size={44} className="mx-auto text-red-400" />
            <h1 className="mt-6 font-display text-2xl font-bold">{t.pay.failed}</h1>
          </>
        )}
        <Link to="/" data-testid="payment-back-home-link" className="btn-outline mt-9 inline-flex text-[11px] font-mono2 uppercase tracking-[0.18em]">
          {t.pay.backHome}
        </Link>
      </div>
    </main>
  );
}
